import React from 'react';
import { motion } from 'framer-motion';

interface NeonTextProps {
    children: React.ReactNode;
    variant?: 'cyan' | 'magenta' | 'green';
    size?: 'small' | 'medium' | 'large';
    animated?: boolean;
    className?: string;
}

const NeonText: React.FC<NeonTextProps> = ({
                                               children,
                                               variant = 'cyan',
                                               size = 'medium',
                                               animated = false,
                                               className = ''
                                           }) => {
    return (
        <motion.span
            className={`neon-text neon-text--${variant} neon-text--${size} ${animated ? 'neon-text--animated' : ''} ${className}`}
            initial={animated ? { opacity: 0 } : {}}
            whileInView={animated ? { opacity: 1 } : {}}
            transition={animated ? { duration: 0.8 } : {}}
        >
            {children}
        </motion.span>
    );
};

export default NeonText;